// @flow
import { generateSchema } from "src/utils/schemaUtils";
import { recordInput } from "src/models/propertyModels/LocationModel";
export default generateSchema([{ name: "locations" }], {
  recordInput
});
